<template>
  <div
      class="popover-wrapper"
      @mouseenter="showPopover"
      @mouseleave="hidePopover"
      ref="triggerRef">
    <slot name="trigger"></slot>
    <teleport to="body">
      <div
          v-if="isVisible"
          ref="popoverRef"
          class="popover-custom-content shadow"
          :style="{ maxWidth: maxWidth }">

        <template v-if="clientData">
          <div
              v-if="userRole !== 'ROLE_COACH' && userRole !== 'ROLE_THERAPIST'"
              v-html="clientData.specialFeatures"></div>

          <div
              v-if="clientData.specialFeaturesForCoach"
              v-html="clientData.specialFeaturesForCoach"
              :class="{'mt-2': userRole !== 'ROLE_COACH' && userRole !== 'ROLE_THERAPIST' && clientData.specialFeatures}">
          </div>
        </template>

        <slot name="content"></slot>

        <div data-popper-arrow class="popover-arrow"></div>
      </div>
    </teleport>
  </div>
</template>
<script setup>
import { createPopper } from '@popperjs/core';
import { defineProps, nextTick, onBeforeUnmount, ref, watch } from 'vue';

const props = defineProps({
  placement: {type: String, default: 'right',},
  offset: {type: Array, default: () => [0, 10],},
  maxWidth: {type: String, default: '350px'},
  clientData: { type: Object, default: null },
  userRole: { type: String, default: '' }
});

const isVisible = ref(false);
const triggerRef = ref(null);
const popoverRef = ref(null);
let popperInstance = null;
const showPopover = () => {
  isVisible.value = true;
};
const hidePopover = () => {
  isVisible.value = false;
};
watch(isVisible, async (value) => {
  if (value) {
    await nextTick();
    if (triggerRef.value && popoverRef.value) {
      popperInstance = createPopper(triggerRef.value, popoverRef.value, {
        placement: props.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: props.offset,
            },
          },
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
            },
          },
          {
            name: 'arrow',
            options: {
              padding: 8,
            },
          },
        ],
      });
    }
  } else {
    if (popperInstance) {
      popperInstance.destroy();
      popperInstance = null;
    }
  }
});
onBeforeUnmount(() => {
  if (popperInstance) {
    popperInstance.destroy();
  }
});
</script>
<style scoped>
.popover-wrapper {
  display: inline-block;
  cursor: pointer;
}
.popover-custom-content {
  background: white;
  padding: 16px;
  border-radius: 4px;
  z-index: 1050; /* Match Bootstrap popover z-index */
  color: #334152;
  width: max-content;
  position: absolute;
  font-size: 1rem; /* Match original $font-size-base * 1.1 */
  line-height: 1.5;
}
.popover-arrow,
.popover-arrow::before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}
.popover-arrow {
  visibility: hidden;
}
.popover-arrow::before {
  visibility: visible;
  content: '';
  transform: rotate(45deg);
}
/* Positioning for arrow based on popper placement */
.popover-custom-content[data-popper-placement^='top'] > .popover-arrow {
  bottom: -4px;
}
.popover-custom-content[data-popper-placement^='bottom'] > .popover-arrow {
  top: -4px;
}
.popover-custom-content[data-popper-placement^='left'] > .popover-arrow {
  right: -4px;
}
.popover-custom-content[data-popper-placement^='right'] > .popover-arrow {
  left: -4px;
}
</style>